/* src/app/components/control-module/timesheet-table/timesheet-table.component.css */
table {
  border-collapse: collapse;
}
tr {
}
/*# sourceMappingURL=timesheet-table.component.css.map */
